import { styled } from "theme/default/styled";

export const SFilterInputInputContainer = styled.div`
  position: relative;
`;
